








































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { Datetime } from 'vue-datetime';
import dayjs from 'dayjs';
import {CalendarRange} from "@/model/calendar/CalendarRange";

@Component({
  components: { Datetime }
})
export default class DateRangeFilter extends Vue {
  @Prop({ default: null }) initialRange: CalendarRange | null;

  private static readonly DAYJS_DATE_FORMAT_ISO: string = "YYYY-MM-DD";

  private startDate: string = null;
  private endDate: string = null;

  created() {
    this.initDates(this.initialRange.startDate, this.initialRange.endDate);
  }

  @Emit("rangeChanged")
  private onRangeChanged() {
    return {
      startDate: this.startDate ? new Date(this.startDate) : null,
      endDate: this.endDate ? new Date(this.endDate) : null
    };
  }

  @Emit("rangeChanged")
  clearRange() {
    this.startDate = null;
    this.endDate = null;
    return new CalendarRange();
  }

  private initDates(startDate: Date | null, endDate: Date | null) {
    this.startDate = startDate ? dayjs(startDate).format(DateRangeFilter.DAYJS_DATE_FORMAT_ISO) : null;
    this.endDate = endDate ? dayjs(endDate).format(DateRangeFilter.DAYJS_DATE_FORMAT_ISO) : null;
  }
}
